// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B_vx1","name":"styles_name__13WEi","phone":"styles_phone__35Vni"};